import axios from 'axios';
import { rootUrl } from '../../../api-handling/rootUrl';

export default axios.create({
  baseURL: rootUrl, //YOUR_API_URL HERE
  headers: {
    'Content-Type': 'application/json',
  },
});
